export class EmailTemplate {
  uid!: string;
  name!: string;
  content!: string;

  constructor(data: object) {
    Object.assign(this, data);
  }
}
